var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "AI智能对话",
        width: "800px",
        visible: _vm.visible,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleDialogClose,
      },
    },
    [
      _c(
        "div",
        { ref: "dialogContent", staticClass: "dialog-content" },
        _vm._l(_vm.messageList, function (item, index) {
          return _c("div", { key: index, staticClass: "message-item" }, [
            item.type === "user"
              ? _c("div", { staticClass: "user-message" }, [
                  _c("span", { staticClass: "message-tag" }, [_vm._v("我：")]),
                  _c("span", { staticClass: "message-content" }, [
                    _vm._v(_vm._s(item.content)),
                  ]),
                ])
              : _c(
                  "div",
                  { staticClass: "ai-message" },
                  [
                    _c("span", { staticClass: "message-tag" }, [
                      _vm._v("AI："),
                    ]),
                    _c("span", {
                      staticClass: "message-content",
                      domProps: { innerHTML: _vm._s(item.content) },
                    }),
                    item.type === "ai" && item.content
                      ? _c("el-button", {
                          staticStyle: { "margin-left": "8px" },
                          attrs: {
                            type: "text",
                            size: "mini",
                            icon: item.isPlaying
                              ? "el-icon-video-pause"
                              : "el-icon-video-play",
                            loading: item.isSynthesizing,
                            disabled: _vm.synthesisStatus === "合成中",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleSpeech(item, index)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
          ])
        }),
        0
      ),
      _vm.speechStatus !== "未连接" && _vm.speechStatus !== "已连接"
        ? _c("div", { staticClass: "speech-status-bar" }, [
            _vm.interimResult
              ? _c("span", { staticClass: "interim-result" }, [
                  _vm._v("实时识别: " + _vm._s(_vm.interimResult)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.synthesisStatus !== "空闲"
        ? _c("div", { staticClass: "speech-status-bar" }, [
            _c("span", { staticClass: "status-text" }, [
              _vm._v("语音合成: " + _vm._s(_vm.synthesisStatus)),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "input-area",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "voice-controls" },
            [
              _c(
                "el-tooltip",
                { attrs: { content: "开始录音", placement: "top" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "voice-btn",
                      attrs: {
                        type: "success",
                        disabled: _vm.isRecording || !_vm.currentToken,
                        size: "small",
                      },
                      on: { click: _vm.startRec },
                    },
                    [_vm._v(" 录音 ")]
                  ),
                ],
                1
              ),
              _c(
                "el-tooltip",
                { attrs: { content: "停止录音", placement: "top" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "voice-btn",
                      attrs: {
                        type: "warning",
                        disabled: !_vm.isRecording,
                        size: "small",
                      },
                      on: { click: _vm.stopRecording },
                    },
                    [_vm._v(" 停止 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-input", {
            staticClass: "input-textarea",
            attrs: {
              type: "textarea",
              placeholder: "请输入您的问题，按回车或点击发送提问...",
              rows: 3,
              disabled: _vm.loading,
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.sendQuestion.apply(null, arguments)
              },
            },
            model: {
              value: _vm.inputValue,
              callback: function ($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "send-btn",
              attrs: {
                type: "primary",
                loading: _vm.loading,
                disabled: _vm.loading || !_vm.inputValue.trim(),
              },
              on: { click: _vm.sendQuestion },
            },
            [_vm._v(" 发送 ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }